<template>
    <svg id="Camada_1" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 129.8 129.8">
        <path
        fill="#ef4444"
            d="M71.76,64.9L128.38,8.27c1.89-1.89,1.89-4.96,0-6.85-1.89-1.89-4.96-1.89-6.85,0l-56.63,56.63L8.27,1.42C6.38-.47,3.31-.47,1.42,1.42-.47,3.31-.47,6.38,1.42,8.27l56.63,56.63L1.42,121.53c-1.89,1.89-1.89,4.96,0,6.85,.95,.95,2.19,1.42,3.43,1.42s2.48-.47,3.43-1.42l56.63-56.63,56.63,56.63c.95,.95,2.19,1.42,3.43,1.42s2.48-.47,3.43-1.42c1.89-1.89,1.89-4.96,0-6.85l-56.63-56.63Z" />
    </svg>
</template>

<script setup>

</script>

<style>

</style>
